<template lang='pug'>
  div()
    app-header
    app-publicities(
      v-if='firstGroup.length > 0'
      :publicities='firstGroup' style="height: 120px;")

    section(class='c-sub-header u-show@tablet' ref='aside_container')
      div(class='c-sub-header__container' ref='aside')
        nav(class='o-wrapper u-flex')
          button(class='c-sub-header__menu' @click='isShowMenu = true')
            i.u-icon menu
          ul(class='c-sub-header__list')
            li(v-for='category in categories' class='u-px3 u-py2')
              router-link(:to="{ name: 'SearchCategory', params: { slug: category.slug }}" class='u-white') {{category.name}}

    //- section(class='c-cover-post o-wrapper' v-if='postsLast.length > 0')
      slick(:options='slickLastPosts' ref='slick')
        router-link( :to="{ name: 'Post', params: { slug: post.slug }}" class='u-block' v-for='(post, index) in postsLast', :key='index')
          figure(class='u-bg-canvas' v-if='post.imageUrl')
            img(class='lazyload u-12/12', :src='post.imageUrl', :data-src='post.imageThumbUrl')
            //- div(v-lazy:background-image="post.imageThumbUrl" lazy='loading')
          p(class='u-white u-bg-canvas u-mt0 u-mb0 u-p3 u-fw-s-bold u-fz-h5') {{post.title}}

      button(class='c-btn-nav c-btn-nav--prev' style='left:1.5rem' @click='$refs.slick.prev()')
        i(class='u-icon') arrow_extend_left
      button(class='c-btn-nav c-btn-nav--next' style='right:1.5rem' @click='$refs.slick.next()')
        i(class='u-icon') arrow_extend_right
      //- swiper(:options='swiperLast')
      //-   swiper-slide(v-for='(post, index) in postsLast', :key='index' class='u-block')
      //-     //- progressive-img(:src='post.imageUrl')
      //-     router-link( :to="{ name: 'Post', params: { slug: post.slug }}" class='u-block')
      //-       figure(class='u-bg-canvas' v-if='post.imageUrl')
      //-         img(class='lazyload u-12/12', :src='post.imageUrl', :data-src='post.imageThumbUrl')
      //-         //- div(v-lazy:background-image="post.imageThumbUrl" lazy='loading')
      //-       p(class='u-white u-bg-canvas u-mt0 u-mb0 u-p3 u-fw-s-bold u-fz-h4') {{post.title}}

    div(class='u-flex o-wrapper_sliders u-9/12@tablet u-justify-between')
      section( style="padding-top: 5px;" class='u-flex-1 u-pb4  o-wrapper_banner' v-if='postsLast.length > 0')
        slick(:options='slickLastPosts' ref='slick')
          router-link( :to="{ name: 'Post', params: { slug: post.slug }}" class='u-block' v-for='(post, index) in postsLast', :key='index')
            figure(class='u-bg-canvas' v-if='post.imageUrl')
              img(class='lazyload u-12/12', :src='post.imageUrl', :data-src='post.imageThumbUrl')
              //- div(v-lazy:background-image="post.imageThumbUrl" lazy='loading')
            p(class='u-white u-bg-canvas u-mt0 u-mb0 u-p3 u-fw-s-bold u-fz-h5') {{post.title}}

      button(class='c-btn-nav c-btn-nav--prev u-show@laptop' style='left:1.5rem' @click='$refs.slick.prev()')
        i(class='u-icon') arrow_extend_left
      button(class='c-btn-nav c-btn-nav--next u-show@laptop' style='right:1.5rem' @click='$refs.slick.next()')
        i(class='u-icon') arrow_extend_right

      aside(class='u-ml4 u-3/12 u-show@laptop' style=' padding-top: 5px;')

        app-publicities(
          v-if='thirdGroup.length > 0'
          :publicities='thirdGroup'
          )

    h3(class='o-wrapper u-mt0')
      span(class='u-title') Noticias Recientes


    div(class='u-flex o-wrapper u-justify-between')
      section(class='u-flex-1 u-pb4')
        app-post(v-for="(post, index) in posts", :post="post", :key='index')

        router-link(:to="{ name: 'Search' }" class='c-btn c-btn--primary u-fw-s-bold u-uppercase') Ver más noticias
        
        //- div(v-html="company.metaKeywords")

      aside(class='u-ml4 u-show@laptop' style='width:345px')
        //- div
            app-publicities(
            v-if='thirdGroup.length > 0'
            :publicities='thirdGroup'
            )

        app-publicities(
          class='u-show@tablet'
          v-if='secondGroup.length > 0'
          :publicities='secondGroup')

        div(v-html="company.metaKeywords")

        p(v-if='company.whatsappNumber' class='u-bg-whatsapp u-flex u-items-center u-px4 u-white u-py3 u-mb3')
          i(class="u-icon u-mr2 u-fz-h3") whatsapp
          span(class='u-fw-bold u-fz-h4') {{ company.whatsappNumber }}


        app-publicities(
          class='u-show@tablet'
          v-if='secondGroup.length > 0'
          :publicities='fourthGroup')

        p(class='u-white u-bg-primary u-mt0 u-mb0 u-fw-s-bold u-uppercase u-px4 u-py3') El tiempo en tacna, rcctacna.com
        div(class='u-px4 u-py3 u-bg-border u-mb3')
          div(id="TT_Fin11111E4ScnBcKKfxzDDzjz7alMKp2bdktkcy5KkD") El tiempo - Tutiempo.net


        div(class='u-px4 u-py3 u-bg-border u-mb3')
          iframe(v-if='company.facebookPage', :src="'https://www.facebook.com/plugins/page.php?href='+ encodeURIComponent(company.facebookPage) + '&tabs=timeline&width=280&height=308&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=1140807346001788'" width="280" height="308" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" class="u-mb2")

        div(class='u-px4 u-py3 u-bg-border u-mb3')
          a(v-if='company.twitterPage' class='twitter-timeline' data-width='280' data-height='400', :href="company.twitterPage") Tweets by RccTacna

        div(class='u-px4 u-py3 u-bg-border u-mb3')
          h3(class='u-title u-mt0') Videos Recientes

          ul( v-if='videos.length > 0' class='u-list-none u-pl0')
            li(class='u-mb3 u-relative' v-for='video in videos', :title='video.title')
              button(
                class="c-video", @click='showVideo(video.videoId)'
                :style="{backgroundImage: `url(http://img.youtube.com/vi/${video.videoId}/mqdefault.jpg)`}")

                i(class='u-icon c-video__icon') youtube_play

              //- label(class='c-video__title') Video
              router-link(:to="{ name: 'Post', params: { slug: video.slug }}" class='c-video__title u-fz-h6') {{video.title | truncate(30)}}

    button(class="c-btn-top", :class="isShowButtonTop ? 'is-show' : ''" @click="goTop()")
      i(class="u-icon u-block") arrow_extend_right

    loading(v-if='isLoading')
    app-off-header(v-if='isShowMenu', @hide='isShowMenu = false')

    app-footer
    modal-video(:url='currentVideo' @hide='isShowModalVideo = false' v-if='isShowModalVideo')
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import axios from 'axios'
  import AppOffHeader from 'components/AppOffHeader'

  export default {
    name: 'HomeScreen',
    components: {AppOffHeader},
    data () {
      return {
        isShowModalVideo: false,
        currentVideo: '',
        isShowMenu: false,
        isLoading: true,
        isShowButtonTop: false,
        videos: [],
        postsLast: [],
        posts: [],
        categories: [],
        secondGroup: [],
        firstGroup: [],
        thirdGroup: [],
        fourthGroup: [],
        currentPage: 1,
        totalPages: 1,
        slickLastPosts: {
          autoplay: true,
          draggable: false,
          pauseOnFocus: false,
          pauseOnHover: false,
          autoplaySpeed: 7500,
          arrows: false,
          centerPadding: '0',
          slidesToScroll: 1,
          slidesToShow: 1,
          adaptiveHeight: true,
          infinite: true
        },
        swiperLast: {
          autoplay: 10000,
          autoHeight: true,
          slidesPerView: 1
        },
        swiperTitle: {
          autoplay: 10000,
          slidesPerView: 3,
          spaceBetween: 20,
          scrollbar: '.swiper-scrollbar',
          breakpoints: {
            600: {
              slidesPerView: 1
            },
            1000: {
              slidesPerView: 2
            }
          }
        }
      }
    },

    computed: {
      ...mapGetters({
        lastPosts: 'lastPosts',
        coverPost: 'coverPost',
        company: 'company'
      })
    },

    methods: {
      ...mapActions({
        loadPublicities: 'loadPublicities'
      }),

      showVideo (id) {
        this.currentVideo = id
        this.isShowModalVideo = true
      },

      handleScroll () {
        let win = window.$(window)

        if (win.scrollTop() >= win.height()) {
          this.isShowButtonTop = true
        } else {
          this.isShowButtonTop = false
        }
      },

      getPosts () {
        axios.get(`${window.API_URL}/posts`)
          .then(({data}) => {
            this.posts = data.data
            this.isLoading = false
          })
      },

      getVideos () {
        axios.get(`${window.API_URL}/posts/videos`)
          .then(({data}) => {
            this.videos = data.data
          })
      },

      getCategories () {
        axios.get(`${window.API_URL}/categories/outstanding`)
          .then(({data}) => {
            this.categories = data.data
          })
      },

      getPublicities () {
        axios.get(`${window.API_URL}/publicities`)
          .then(({data}) => {
            this.firstGroup = data.firstGroup
            this.secondGroup = data.secondGroup
            this.thirdGroup = data.thirdGroup
            this.fourthGroup = data.fourthGroup
          })
      },

      getPostsLast () {
        axios.get(`${window.API_URL}/posts/last`)
          .then(({data}) => {
            this.postsLast = data.data
          })
      },

      initTime () {
        let DivTutiempo = document.getElementById('TT_Fin11111E4ScnBcKKfxzDDzjz7alMKp2bdktkcy5KkD')
        if (DivTutiempo) {
          DivTutiempo.style.cssText = 'width:277px; height:71px; color:#000000;background:#FFFFFF; overflow:hidden;'
          DivTutiempo.innerHTML = '<iframe id="TTF_Fin11111E4ScnBcKKfxzDDzjz7alMKp2bdktkcy5KkD" src="https://www.tutiempo.net/s-widget/tt_NXx8RkZGRkZGfG58bnxufDEwMzU4NHwyMHw5fDF8MXwzfDJ8MjV8c3xzfG58RTg2RjZGfDcxQjlGMHx8fDAwMDAwMHw1NHwzfDQ5fDUwfDEyMHwxOHw2MHwwfDI3N3w3MXw0M3wzMHwxM3wxM3wyNHw0M3wyNHxpTHwxfA%2C%2C" frameborder="0" scrolling="no" width="100%" height="100%" allowtransparency="allowtransparency" style="overflow:hidden;"></iframe>'
        } else {
          // window.alert('Error en la carga del API del tiempo\nEl cÃ³digo introducido no es correcto\nPara mas informaciÃ³n: www.tutiempo.net')
        }
      },

      goTop () {
        window.$('body').animate({scrollTop: 0}, '2000', 'swing')
      }
    },

    created () {
      this.getVideos()
      this.getPostsLast()
      this.getCategories()
      this.getPosts()
      this.getPublicities()
    },

    mounted () {
      window.addEventListener('scroll', this.handleScroll)
      this.initTime()
      setTimeout(() => {
        try {
          window.twttr.widgets.load()
        } catch (e) {
        }

        let $aside = window.$(this.$refs.aside)
        let $asideContainer = window.$(this.$refs.aside_container)

        $asideContainer.css({ 'height': `${$aside.height()}px` })
        $aside.pushpin({
          top: $aside.offset().top
        })
      }, 1100)
    },

    destroyMounted () {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/screens/Home/components/HomeScreen.vue